export class updateSiteContactMethodResourceModel {
  constructor(
    contactMethodId = null,
    siteContactMethodValue = '',
    isPreferred = true
  ) {
    this.contactMethodId = contactMethodId;
    this.siteContactMethodValue = siteContactMethodValue;
    this.isPreferred = isPreferred;
  }
}
